// extracted by mini-css-extract-plugin
export default {"playButton":"image-view_playButton__rxV+r"};